import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrDocumentsApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    documentTypes(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrDocumentType[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrDocumentType[]>>(`${this.baseUrl}/document-types`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveDocumentType(request: HrModels.HrDocumentType): Observable<APIResponseWrapper<HrModels.HrDocumentType>> {
        return request.documentTypeId
          ? this.http.put<APIResponseWrapper<HrModels.HrDocumentType>>(`${this.baseUrl}/document-types/${request.documentTypeId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrDocumentType>>(`${this.baseUrl}/document-types`, request);
      }
    
    employeeDocuments(employeeId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrEmployeeDocument[]>>(`${this.baseUrl}/employees/${employeeId}/documents`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveEmployeeDocument(employeeId: number, request: HrModels.HrEmployeeDocument): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument>> {
        return request.documentId
          ? this.http.put<APIResponseWrapper<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/documents/${request.documentId}`, { ...request, employeeId })
          : this.http.post<APIResponseWrapper<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/employees/${employeeId}/documents`, request);
      }
    
    documents(filters: HrModels.HrEmployeeDocumentFilters = {}): Observable<HrModels.HrApiList<HrModels.HrEmployeeDocument>> {
        return this.http.get<HrModels.HrApiList<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/documents`, {
          params: this.params(filters)
        });
      }
    
    verifyDocument(documentId: number, reason?: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/documents/${documentId}/verify`, { reason }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    rejectDocument(documentId: number, reason: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/documents/${documentId}/reject`, { reason }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    waiveDocument(documentId: number, reason?: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployeeDocument>>(`${this.baseUrl}/documents/${documentId}/waive`, { reason }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    copyDriverLegalDocuments(employeeId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployeeDocument[]>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployeeDocument[]>>(`${this.baseUrl}/employees/${employeeId}/documents/copy-driver-legal`, null, {
          params: this.params({ owningCompanyId })
        });
      }
    
    documentCenter(owningCompanyId?: number, status?: string, workerCategory?: string): Observable<APIResponseWrapper<HrModels.HrDocumentCenter>> {
        return this.http.get<APIResponseWrapper<HrModels.HrDocumentCenter>>(`${this.baseUrl}/documents/center`, {
          params: this.params({ owningCompanyId, status, workerCategory })
        });
      }
    
    evaluateDocuments(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrDocumentEvaluationResult>> {
        return this.http.post<APIResponseWrapper<HrModels.HrDocumentEvaluationResult>>(`${this.baseUrl}/documents/evaluate`, null, {
          params: this.params({ owningCompanyId })
        });
      }
  };
}
